import { render, staticRenderFns } from "./forkliftDetailOnWay.vue?vue&type=template&id=0add0d98&scoped=true"
import script from "./forkliftDetailOnWay.vue?vue&type=script&lang=js"
export * from "./forkliftDetailOnWay.vue?vue&type=script&lang=js"
import style0 from "./forkliftDetailOnWay.vue?vue&type=style&index=0&id=0add0d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0add0d98",
  null
  
)

export default component.exports